class DetailsModal extends HTMLElement {
    constructor() {
        super(),
            (this.detailsContainer = this.querySelector("details")),
            (this.summaryToggle = this.querySelector("summary")),
            this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close()),
            this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this)),
            this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this)),
            this.summaryToggle.setAttribute("role", "button");
        this.searchFocusContainer = this.classList.contains('header__search') ? this.querySelector('.search-modal__content') : null;
        this.onSearchTab = this.onSearchTab.bind(this);
        this.onSearchFocus = this.onSearchFocus.bind(this);
    }
    isOpen() {
        return this.detailsContainer.hasAttribute("open");
    }
    onSummaryClick(event) {
        event.preventDefault(), event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
    }
    onBodyClick(event) {
        (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) && this.close(!1);
    }
    open(event) {
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.focusFrame);
        document.body.classList.add("overflow-hidden"),
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
            event.target.closest("details").setAttribute("open", !0),
            document.body.addEventListener("click", this.onBodyClickEvent);
        this.summaryToggle.setAttribute('aria-expanded', 'true');
        const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
        if (this.searchFocusContainer) {
            removeTrapFocus();
            document.addEventListener('keydown', this.onSearchTab);
            document.addEventListener('focusin', this.onSearchFocus);
            // The theme delays visibility during its entrance animation.
            const focusWhenVisible = () => {
                if (getComputedStyle(input).visibility !== 'visible') {
                    this.focusFrame = requestAnimationFrame(focusWhenVisible);
                    return;
                }
                if (!this.searchFocusContainer.contains(document.activeElement)) input.focus();
            };
            focusWhenVisible();
        } else {
            trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), input);
        }
    }
    getSearchFocusables() {
        // Results and popular terms change while the dialog stays open.
        return getFocusableElements(this.searchFocusContainer).filter((element) =>
            element.tabIndex >= 0 && !element.closest('[inert]') &&
            element.getClientRects().length && getComputedStyle(element).visibility === 'visible'
        );
    }
    onSearchTab(event) {
        if (event.key !== 'Tab') return;
        const elements = this.getSearchFocusables();
        const first = elements[0] || this.searchFocusContainer;
        const last = elements[elements.length - 1] || first;
        if (!elements.includes(document.activeElement) ||
            (event.shiftKey && document.activeElement === first) ||
            (!event.shiftKey && document.activeElement === last)) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
        }
    }
    onSearchFocus(event) {
        if (!this.searchFocusContainer.contains(event.target)) {
            (this.getSearchFocusables()[0] || this.searchFocusContainer).focus();
        }
    }
    close(focusToggle = !0) {
        cancelAnimationFrame(this.focusFrame);
        document.removeEventListener('keydown', this.onSearchTab);
        document.removeEventListener('focusin', this.onSearchFocus);
        this.querySelector('predictive-search')?.close();
        this.summaryToggle.setAttribute('aria-expanded', 'false');
        clearTimeout(this.closeTimer);
        document.body.classList.remove("overflow-hidden"),
            removeTrapFocus(focusToggle ? this.summaryToggle : null),
            this.closeTimer = setTimeout(() => {
                this.detailsContainer.removeAttribute("open"), document.body.removeEventListener("click", this.onBodyClickEvent);
            }, 400);
    }
    disconnectedCallback() {
        cancelAnimationFrame(this.focusFrame);
        clearTimeout(this.closeTimer);
        document.removeEventListener('keydown', this.onSearchTab);
        document.removeEventListener('focusin', this.onSearchFocus);
        document.body.removeEventListener('click', this.onBodyClickEvent);
    }
}
customElements.define("details-modal", DetailsModal);
